<p-tabView styleClass="hvl-tabview-without-bg" (onChange)="onTabChange($event)">
    <p-tabPanel [header]="'hrMultiTypeImageUploader.takePhoto' | translate">
        <div class="flex justify-content-center">
            @if (capturedImage) {
                <img [src]="capturedImage.imageAsDataUrl" class="per-image" loading="lazy"
                     [width]="400"
                     [height]="303"
                     alt="…"/>
            }@else{
                @if (!cameraError) {
                    <webcam [trigger]="$trigger" (imageCapture)="capture($event)" (initError)="handleInitError($event)"
                            [width]="400" [height]="300"></webcam>
                } @else {
                    {{'hrMultiTypeImageUploader.cameraError' | translate}}
                }
            }
        </div>
        @if (!cameraError) {
            <div class="flex justify-content-center">
                <button pButton type="button" class="p-button p-button-outlined" icon="pi"
                        (click)="captureImage()">{{'hrMultiTypeImageUploader.takePhoto' | translate}}</button>
                <button pButton type="button" class="p-button p-button-outlined" icon="pi"
                        (click)="deleteImage()">{{'hrMultiTypeImageUploader.deletePhoto' | translate}}</button>
            </div>
        }
    </p-tabPanel>
    <p-tabPanel [header]="'hrMultiTypeImageUploader.uploadFromFile' | translate">
        <p-fileUpload
            #fileUpload
            styleClass="hvl-file-upload"
            name="attachments"
            id="attachments"
            customUpload="true"
            accept=".pdf,.xls,.xlsx,.doc,.docx,image/jpg,image/jpeg"
            [showCancelButton]="false"
            [showUploadButton]="false"
            [multiple]="false"
            (onSelect)="fileSelect($event)"
            (onRemove)="fileRemove($event)"
            chooseIcon="pi pi-cloud-upload"
            chooseLabel="{{ 'hrMultiTypeImageUploader.form.browse' | translate }}"
            invalidFileTypeMessageSummary="{{ 'hrMultiTypeImageUploader.form.invalidFileTypeMessageSummary' | translate }}"
            invalidFileTypeMessageDetail="{{ 'hrMultiTypeImageUploader.form.invalidFileTypeMessageDetail' | translate }}"
            draggable="true"
        >
            <ng-template pTemplate="content">
                <div *ngIf="(!fileUpload?.files || fileUpload?.files?.length === 0) && !files" class="file-upload-content">
                    <label>{{ 'hrMultiTypeImageUploader.form.fileDragDropLabel' | translate }}</label>
                </div>
            </ng-template>
        </p-fileUpload>
    </p-tabPanel>
</p-tabView>
<ui-form-footer-buttons (onSave)="onSave()" (onCancel)="onCancel()"
                        [showCancel]="true"
                        [showSave]="true"></ui-form-footer-buttons>
